import { useState } from "react";
import { toast } from "react-hot-toast";
import { CloseIcon } from "../../kits/Icons";
import {
  CustomInput,
  ReactSelect,
  FileInputSecond,
} from "../../kits/Inputs/Inputs";
import CustomButton from "../../kits/button/CustomButton";

import FinalProductDetail from "./FinalProductDetail";
import PreviewImage from "./PreviewImage";
import PrimaryProductDetail from "./PrimaryProductDetail";
import ServiceProductDetail from "./ServiceProductDetail";

export default function ProductDetail({
  productStructure,
  changeFirstTabData,
  data,
  mainTypeProduct,
  addProductFunFinal,
  setBodyText,
  bodyTxt,
  addOrEdit,
  attributeProductList,
}) {
  const [formulationList, setFormulationList] = useState([]);

  const deleteItemFromImages = (index) => {
    let imagesTemp = data?.mainImgFiles;
    imagesTemp.splice(index, 1);
    changeFirstTabData(imagesTemp, "mainImgFilesAll");
  };
  const validate = () => {
    let validate = true;
    if (
      data.title == undefined ||
      data.title == "" ||
      data.productType == -1 ||
      data.productType == undefined
    ) {
      validate = false;
      toast.error("لطفا عنوان و نوع محصول را مشخص کنید.");
    } else if (data?.benefit_type?.value == 2 && data?.benefit_value > 100) {
      validate = false;
      toast.error("مبلع تغییر قیمت نباید بیشتر از 100 باشد.");
    } else if (data?.discount_type?.value == 2 && data?.discount > 100) {
      validate = false;
      toast.error("مبلع تخفیف نباید بیشتر از 100 باشد.");
    }

    return validate;
  };

  const addProductFunc = () => {
    if (validate()) addProductFunFinal(formulationList);
  };
  return (
    <div>
      <div className="d-flex flex-wrap">
        <div className="col-6 col-sm-3  my-1 px-1">
          <CustomInput
            label="عنوان"
            inputSize="lg"
            type="text"
            inputContainer=""
            inputClassName=""
            inputValue={data.title}
            activate={addOrEdit == "edit" ? "disabled" : ""}
            onChangeFunc={(e) => {
              changeFirstTabData(e.target.value, "title");
            }}
            // textErr={validationTxt.answers}
          />
        </div>
        <div className=" col-6 col-sm-3 my-1 px-1">
          <ReactSelect
            title="نوع محصول"
            itemsList={productStructure}
            inputContainer=""
            inputSize="lg"
            inputValue={data?.productType}
            activate={addOrEdit == "edit" ? false : true}
            onChangeFunc={(e) => {
              changeFirstTabData(e, "productType");
            }}
            textErr={""}
          />
        </div>
        <div className="col-12 col-sm-6  my-1">
          <CustomInput
            label="توضیحات کوتاه"
            inputSize="lg"
            type="text"
            inputType="textarea"
            inputContainer=""
            inputClassName=""
            activate={addOrEdit == "edit" ? "disabled" : ""}
            inputValue={data.description}
            onChangeFunc={(e) => {
              changeFirstTabData(e.target.value, "description");
            }}

            // textErr={validationTxt.answers}
          />
        </div>
      </div>

      <div className="d-flex flex-wrap my-1">
        <div className="col-12 col-sm-6 col-md-3  px-1">
          <ReactSelect
            title="واحد"
            itemsList={[
              { value: 1, label: "مترمربع" },
              { value: 2, label: "سی سی" },
              { value: 3, label: "عدد" },
            ]}
            activate={addOrEdit == "edit" ? false : true}
            inputContainer=""
            inputSize="lg"
            inputValue={data.unit}
            onChangeFunc={(e) => changeFirstTabData(e, "unit")}
            textErr={""}
          />
        </div>
        {addOrEdit != "edit" && (
          <div className="col-12 col-sm-6 col-md-3 px-1 align-self-start">
            <FileInputSecond
              id="add-new-file-single-product"
              label="عکس اصلی"
              onChangeFunc={(e) => {
                changeFirstTabData(e.target.files[0], "mainImg");
              }}
              accept="image/*"
            />
            {data?.mainImg != undefined && data?.mainImg != "" && (
              <PreviewImage
                onChangeFunc={() => changeFirstTabData("", "mainImg")}
                fileValue={data.mainImg}
              />
            )}
          </div>
        )}

        {mainTypeProduct == 1 && addOrEdit != "edit" && (
          <div className="col-12 col-sm-6 flex-grow-1 ">
            <div className="col-12 col-md-6 ">
              {" "}
              <FileInputSecond
                id="add-new-file-single-product-multiple"
                label="عکسهای جانبی"
                onChangeFunc={(e) => {
                  console.log("object");
                  changeFirstTabData(e.target.files[0], "mainImgFiles");
                }}
                multiple={false}
                accept="image/*"
              />
            </div>

            <div className="d-flex flex-wrap">
              {data?.mainImgFiles != undefined &&
                data?.mainImgFiles?.map((value, index) => (
                  <div className="mx-1">
                    <PreviewImage
                      onChangeFunc={() => deleteItemFromImages(index)}
                      fileValue={value}
                    />
                  </div>
                ))}
            </div>
          </div>
        )}
      </div>

      {addOrEdit == "edit" && data?.files?.length > 0 && (
        <div className="d-flex flex-wrap">
          {data?.files?.map((value, index) => (
            <div className="mx-1">
              <PreviewImage
                onChangeFunc={() => {}}
                fileValue={value?.path}
                show={true}
              />
            </div>
          ))}
          <div className="mx-1">
            <PreviewImage
              onChangeFunc={() => {}}
              fileValue={data?.cover}
              show={true}
            />
          </div>
        </div>
      )}
      {mainTypeProduct == 1 && (
        <div>
          <FinalProductDetail
            changeFirstTabData={changeFirstTabData}
            data={data}
            setBodyText={setBodyText}
            bodyTxt={bodyTxt}
            addOrEdit={addOrEdit}
          />
        </div>
      )}
      {mainTypeProduct == 3 && (
        <div>
          <PrimaryProductDetail
            changeFirstTabData={changeFirstTabData}
            data={data}
            addOrEdit={addOrEdit}
          />
        </div>
      )}
      {mainTypeProduct == 2 && (
        <div>
          <ServiceProductDetail
            changeFirstTabData={changeFirstTabData}
            data={data}
            addOrEdit={addOrEdit}
          />
        </div>
      )}
      {addOrEdit != "edit" && (
        <div className="mt-1">
          <CustomButton
            color="success"
            size="medium"
            state={"normal"}
            circle={false}
            className={"ms-auto"}
            onClick={() => addProductFunc()}
            // style={{ opacity: deactivateItems && "0.4" }}
          >
            ثبت نهایی
          </CustomButton>
        </div>
      )}
    </div>
  );
}
